import { render, staticRenderFns } from "./info.html?vue&type=template&id=176fac61&"
import script from "./info.js?vue&type=script&lang=js&"
export * from "./info.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports